module.exports = __webpack_public_path__ + "img/7.0f0e2e24.jpg";